module.exports = __webpack_public_path__ + "static/media/bookkeeping.666898d8.svg";